import React from "react";

// USER TABS
function Tab(props) {
	// CATEGORIES OR EMPTY OBJECT
	const categories = props.categories ? props.categories : {};

	// TAB TITLE
	const title = props.title;

	return (
		<div className="Tab">
			<div className="tab-header-div">
				{/* TAB TITLE */}
				<h2 className="h2-tab">{title}</h2>
			</div>

			<div className="tab-wrapper">
				{/* MAP CATEGORY COMPONENT */}
				{Object.keys(categories).map((catID, index) => {
					return <Category category={categories[catID]} key={catID} />;
				})}
			</div>
		</div>
	);
}

// USER CATEGORIES
function Category(props) {
	// CATEGORY TITLE
	const title = props.category.title;

	// LABEL OR EMPTY OBJECT
	const labels = props.category.labels ? props.category.labels : {};

	return (
		<ul className="Category">
			<div className="tab-header-div">
				{/* CATEGORY TITLE */}
				<h3 className="h3-category">{title}</h3>
			</div>

			{/* LI MAP LABEL */}
			<li>
				{Object.keys(labels).map((labelID, index) => {
					return (
						// LABEL COMPONENT
						<Label
							links={labels[labelID].links}
							title={labels[labelID].title}
							key={labelID}
						/>
					);
				})}
			</li>
		</ul>
	);
}

// USER LABELS AND LINKS
function Label(props) {
	// LABEL TITLE
	const title = props.title;
	// GET ARRAY OF KEYS OF LINKS OBJECT
	const linksIDS = props.links ? Object.keys(props.links) : [];
	// TRANSFORM LINKS OBJECT KEYS INTO LINKS ARRAY WITH IDS
	const links = linksIDS.map((linkID) => {
		return Object.assign({ linkID }, props.links[linkID]);
	});

	return (
		<ul className="SubTitle">
			<div className="tab-header-div">
				{/* LABEL TITLE */}
				<h4 className="h4-subtitle">{title}</h4>
			</div>

			{/* LI MAP LINK */}
			{links.map((item, index) => {
				// DESCRIPTION OR URL
				const descriptionURL = item.description ? item.description : item.url;
				return (
					<li className="bookmark-li-el" key={`i${index}`}>
						{/* URL LINK */}
						<a
							className="bookmark-link bookmark-link-users"
							href={item.url}
							target="_blank"
							rel="noopener noreferrer"
							title={descriptionURL}
						>
							{item.name}
						</a>
					</li>
				);
			})}
		</ul>
	);
}

function UserTabsBrowse(props) {
	// GET ARRAY OF KEYS OF TABS OBJECT
	const tabs = props.user.tabs ? props.user.tabs : {};
	const tabsArr = Object.keys(tabs);

	// TRANSFORM TABS OBJECT KEYS INTO TABS ARRAY WITH IDS
	const tabsWithID = tabsArr.map((tabID) => {
		return Object.assign({ tabID }, tabs[tabID]);
	});

	return (
		<main className="Main">
			{/* COMPONENT MAP TABS */}
			{tabsWithID.map((item) => {
				return (
					<Tab
						title={item.title}
						categories={item.categories}
						key={item.tabID}
					/>
				);
			})}
			<footer className="tab-footer-home">
				<p className="p-footer-home">Share this page:</p>
				<a
					className="link-footer-home link-footer-browse"
					href={window.location.href}
				>
					{window.location.href}
				</a>
				<h3 className="h3-footer-home h3-footer-browse">
					{props.user.userName}
				</h3>
			</footer>
		</main>
	);
}

export default UserTabsBrowse;
